import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { useStore } from '../../../app/stores/store';
import './dashboard.css';
import ApproveModal from './../../../app/common/modals/ApproveModal';
import ReportsModal from '../../TableReports/ReportsModal';
import { v4 as uuid } from 'uuid';
import { Activity } from '../../../app/models/activity';
import _ from 'lodash';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import { initialPostFilteredItemDetails, PostFilteredItemDetailsTypes } from '../../../app/models/metaDataConfig';

interface Props {
  selectedType: any;
  selectedTask: any;
}

function DashboardProdPlanTable({ selectedType, selectedTask }: Props) {
  const { activityStore, dashboardStore, commonStore } = useStore();
  const { userReadableDateFormat } = commonStore;
  const {
    activitiesByDate,
    loadTagPagination,
    loadProductionPagination,
    loadProductionTable,
    NFAIRestorationProductionPlanningSearch
  } = activityStore;
  const [pageNumber, setPageNumber] = useState(
    dashboardStore.dashboard.setProdPageNumber,
  );
  //  const [emptloading,setEmptloading] = useState(false);

  // useEffect(()=>{
  //  loadProductionPagination(selectedType,selectedTask,1);
  //  // eslint-disable-next-line
  // },[selectedTask]);
  useEffect(() => {
    if (dashboardStore.dashboard.setProdPageNumber === 1) {
      setPageNumber(dashboardStore.dashboard.setProdPageNumber);
    }
  }, [dashboardStore.dashboard.setProdPageNumber]);

  const tableData: Activity[] = [];
  activitiesByDate.forEach((a) => {
    delete a?.isMaster;
    // eslint-disable-next-line
    delete a?.sections_Multiple_From;
    delete a?.sections_From;

    tableData?.push({
      ...a,
      movementdate: userReadableDateFormat(a.movementdate),
      movement_Time: userReadableDateFormat(a.movement_Time),
      maintenance: userReadableDateFormat(a.maintenance),
      receivingdate: userReadableDateFormat(a.receivingdate),
      status_Time: userReadableDateFormat(a.status_Time),
      itemCreatedAt: userReadableDateFormat(a.itemCreatedAt),
    });
  });

  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,typeid,thumbnail,preview,proxy,global_positioning_system,isHost,elementtypeid,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost,clearedon';
  const assettable = JSON.parse(JSON.stringify(tableData));
  assettable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));
  // useEffect(()=>{
  //   setEmptloading(true);
  //   setTimeout(() => {
  //     setEmptloading(false);
  //   }, 250);
  //   },[typeProduction,taskTypeProduction])
  const paginateFunction = (e: number) => {
    let destructData = dashboardStore.dashboard;

    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
       const newObj = dashboardStore.dashboard.searchfilterparams;
       const payload:PostFilteredItemDetailsTypes = {
            ...initialPostFilteredItemDetails,
            title: newObj?.title || '',            
            currentTask: newObj?.current_task || '',
            currentSubtask: newObj?.current_subtask || '',
            status: newObj?.status || '',
            Previoustask: newObj?.previoustask || newObj?.previousTask || '',
            PreviousSubtask: newObj?.previoussubtask || newObj?.previousSubtask || '',
            PageNumber: e || 1
          }
      commonStore.NFAIReportCustomer ? NFAIRestorationProductionPlanningSearch(payload)
      : activityStore.searchProductionPlanning(
        destructData.setProductionType,
        destructData.setProductionTask,
        destructData.searchfilterparams,
        e,
      );
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      activityStore.sortProductionPlanning(
        destructData.setProductionType,
        destructData.setProductionTask,
        destructData.orderName,
        destructData.orderData,
        e,
      );
    } else {
       const newObj = dashboardStore.dashboard.searchfilterparams;
       const payload:PostFilteredItemDetailsTypes = {
            ...initialPostFilteredItemDetails,
            title: newObj?.title || '',
            currentTask: newObj?.current_task || '',
            currentSubtask: newObj?.current_subtask || '', 
            status: newObj?.status || '',
            Previoustask: newObj?.previoustask || newObj?.previousTask || '',
            PreviousSubtask: newObj?.previoussubtask || newObj?.previousSubtask || '',
            PageNumber: e || 1
          }
      commonStore.NFAIReportCustomer ? NFAIRestorationProductionPlanningSearch(payload)
      : loadProductionPagination(
        destructData.setProductionType,
        destructData.setProductionTask,
        e,
      );
    }
    dashboardStore.setProdDataPageNum(e);
    setPageNumber(e);
  };
  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };
  // if (!loadTagPagination || loadProductionTable) return  <div style={{ height: "40vh" }}> <LoadingComponent /> </div> ;

  return (
    <div>
      {dashboardStore.dashboard.DenialModal === true ? (
        <ApproveModal />
      ) : dashboardStore.dashboard.reportsConfiguration === true ? (
        <ReportsModal
          toggleProps={dashboardStore.dashboard.tableconfigurationClicked}
        />
      ) : null}

      <DynamicTableComponent
        key={uuid()}
        data={assettable}
        name={'prodPlanTable'}
        actiontype={''}
        pageFunc={paginateFunction}
        pageNumData={pageNumber}
        searchFuncData={searchFunction}
        loading={!loadTagPagination || loadProductionTable}
      />
    </div>
  );
}
export default observer(DashboardProdPlanTable);
